import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Car, CarsState } from "../../../(general-header)/prizes/cars/macros/ourCars/types";

const initialState: CarsState = {
  filteredList: [],
  ticketPrice: [],
  rrp: [],
  topMPH: [],
  bhp: [],
  zeroTo60: [],
  filterHeaderHeight: 0,
  filter: null,
  activeTab: "prizes",
  viewCarsDivHeight: 0,
};

export const carsSlice = createSlice({
  name: "ourCars",
  initialState,
  reducers: {
    publishFilteredCars: (state, action: PayloadAction<{ cars: Car[] }>) => {
      state.filteredList = action.payload.cars;
    },
    publishTicketPrice: (state, action: PayloadAction<{ value: number[] }>) => {
      state.ticketPrice = action.payload.value;
    },
    publishRRP: (state, action: PayloadAction<{ value: number[] }>) => {
      state.rrp = action.payload.value;
    },
    publishTopMPH: (state, action: PayloadAction<{ value: number[] }>) => {
      state.topMPH = action.payload.value;
    },
    publishZeroTo60: (state, action: PayloadAction<{ value: number[] }>) => {
      state.zeroTo60 = action.payload.value;
    },
    publishBHP: (state, action: PayloadAction<{ value: number[] }>) => {
      state.bhp = action.payload.value;
    },
    publishFilterHeaderHeight: (state, action: PayloadAction<{ value: number }>) => {
      state.filterHeaderHeight = action.payload.value;
    },
    publishFilterValues: (state, action: PayloadAction<{ value: { category: keyof Car; value: string } }>) => {
      state.filter = action.payload.value;
    },
    publishActiveTab: (state, action: PayloadAction<{ value: string }>) => {
      state.activeTab = action.payload.value;
    },
    publishViewCarsDivHeight: (state, action: PayloadAction<{ value: number }>) => {
      state.viewCarsDivHeight = action.payload.value;
    },
  },
});

export const {
  publishFilteredCars,
  publishTicketPrice,
  publishRRP,
  publishTopMPH,
  publishZeroTo60,
  publishBHP,
  publishFilterHeaderHeight,
  publishFilterValues,
  publishActiveTab,
  publishViewCarsDivHeight,
} = carsSlice.actions;

export default carsSlice.reducer;
